import React from 'react'

const RecaptchaLegalText = () => {
  let recaptchaEnabled = window?.app_data?.appcmsMain?.security?.reCaptchaKeys?.isEnabled
  return (<>
  {recaptchaEnabled ? <div className='recaptcha-legal-text'>
  This site is protected by reCAPTCHA and the Google 
    <a aria-label="Privacy Policy" href="https://policies.google.com/privacy">Privacy Policy</a> and  
    <a aria-label="Terms of Service" href="https://policies.google.com/terms">Terms of Service</a> apply.
    </div> : <></>}
    </>)
}

export default RecaptchaLegalText